var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "main" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.isLoading,
            expression: "isLoading",
          },
        ],
      },
      [_c("v-page-loading")],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.isLoading,
            expression: "!isLoading",
          },
        ],
      },
      [
        _c("v-page-header", { attrs: { title: _vm.getPageTile } }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.hasLoadingError,
                expression: "hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("p", { staticClass: "text-center" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.loadingError) +
                    "\n                "
                ),
              ]),
            ]),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.hasLoadingError,
                expression: "!hasLoadingError",
              },
            ],
          },
          [
            _c("div", { staticClass: "grid-container" }, [
              _c("div", { staticClass: "grid-x" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "cell medium-9 medium-offset-1 large-11 large-offset-0",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "wrapper" },
                      [
                        _c("v-action-buttons", {
                          attrs: { items: _vm.getActionButtons },
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "box" },
                          [
                            _c("v-navigation"),
                            _vm._v(" "),
                            _c("div", { staticClass: "grid-x align-center" }, [
                              _c("div", { staticClass: "cell small-6" }, [
                                _c("h2", [
                                  _vm._v(_vm._s(_vm.$t("customers.info"))),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "content" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "content__item" },
                                      [
                                        _c("p", [
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.customerObject.headquarter
                                                  .company_name
                                              )
                                            ),
                                          ]),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("customers.client_number")
                                            ) +
                                              ": " +
                                              _vm._s(
                                                _vm.customerObject.client_number
                                              )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(_vm.$t("form.phone")) +
                                              ": " +
                                              _vm._s(
                                                _vm.customerObject.headquarter
                                                  .phone
                                              )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "content__item" },
                                      [
                                        _vm.customerObject.contact_person
                                          ? [
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "customers.contact_person"
                                                    )
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(" "),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.customerObject
                                                      .contact_person
                                                  )
                                                ),
                                              ]),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerObject.headquarter
                                                .email
                                            )
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "content__item" },
                                      [
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerObject.headquarter
                                                .address1
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerObject.headquarter
                                                .address2
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.customerObject.headquarter
                                                .zipcode
                                            ) +
                                              " " +
                                              _vm._s(
                                                _vm.customerObject.headquarter
                                                  .city
                                              )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c("p", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$helpers.countries[
                                                _vm.customerObject.headquarter
                                                  .country_code
                                              ]
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm.$store.getters.userIsAdmin
                                      ? [
                                          _c(
                                            "div",
                                            { staticClass: "content__item" },
                                            [
                                              _vm.customerObject.headquarter
                                                .risk
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "content__item",
                                                    },
                                                    [
                                                      !_vm.customerObject
                                                        .headquarter.risk
                                                        .is_valid
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "u-color--alert",
                                                            },
                                                            [
                                                              _c("strong", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "location.risk.not_valid"
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _c("p", [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "location.risk.risk_number"
                                                              )
                                                            ) +
                                                              ": " +
                                                              _vm._s(
                                                                _vm
                                                                  .customerObject
                                                                  .headquarter
                                                                  .risk
                                                                  .risk_number
                                                              )
                                                          ),
                                                        ]),
                                                      ]),
                                                      _vm._v(" "),
                                                      _vm.customerObject
                                                        .headquarter.risk
                                                        .decided_budget
                                                        ? _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "location.risk.decided_budget"
                                                                )
                                                              ) +
                                                                ": " +
                                                                _vm._s(
                                                                  _vm.$helpers.formateCurrency(
                                                                    _vm
                                                                      .customerObject
                                                                      .headquarter
                                                                      .risk
                                                                      .decided_budget
                                                                  )
                                                                )
                                                            ),
                                                          ])
                                                        : _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "u-color--alert",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "\n                                                          " +
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "location.risk.decided_budget.not_exist"
                                                                    )
                                                                  ) +
                                                                  "\n                                                        "
                                                              ),
                                                            ]
                                                          ),
                                                      _vm._v(" "),
                                                      _vm.customerObject
                                                        .headquarter.risk
                                                        .valid_from
                                                        ? _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "location.risk.valid_from"
                                                                )
                                                              ) +
                                                                ": " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    _vm
                                                                      .customerObject
                                                                      .headquarter
                                                                      .risk
                                                                      .valid_from,
                                                                    "DD.MM.YYYY"
                                                                  )
                                                                )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.customerObject
                                                        .headquarter.risk
                                                        .valid_until
                                                        ? _c("p", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "location.risk.valid_until"
                                                                )
                                                              ) +
                                                                ": " +
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "moment"
                                                                  )(
                                                                    _vm
                                                                      .customerObject
                                                                      .headquarter
                                                                      .risk
                                                                      .valid_until,
                                                                    "DD.MM.YYYY"
                                                                  )
                                                                )
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.locationsWithRiskWarnings()
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "content__item",
                                                    },
                                                    [
                                                      _vm.locationsWithoutRiskExists()
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "u-color--alert",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "location.risk.some.locations.without.risk"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.locationsWithoutBudgetExist()
                                                        ? _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "u-color--alert",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "location.risk.decided_budget.not_exist"
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      : _vm._e(),
                                  ],
                                  2
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "cell small-6 large-8 xxlarge-6",
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "grid-x align-middle" },
                                    [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "cell auto" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "data__numbers data__numbers--center",
                                          },
                                          [
                                            _c(
                                              "div",
                                              { attrs: { "data-static": "" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    attrs: {
                                                      "data-static-number":
                                                        _vm
                                                          .projectsGrapInformation
                                                          .open,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .projectsGrapInformation
                                                          .open
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "is-bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "customers.projects_open"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { attrs: { "data-static": "" } },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "u-color--orange",
                                                    attrs: {
                                                      "data-static-number":
                                                        _vm
                                                          .projectsGrapInformation
                                                          .busy,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm
                                                          .projectsGrapInformation
                                                          .busy
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "is-bold" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "customers.projects_partly_done"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cell shrink" }, [
      _c("div", { staticClass: "graphic graphic--circle show-for-xxlarge" }, [
        _c("canvas", { attrs: { id: "graphic__doughnut", height: "272" } }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }